import { notifications } from '@mantine/notifications';
import { resetPassword } from '../../apiClient';
import { useAuthStore } from '../../../store';
import { useMutation } from '@tanstack/react-query';

const useResetPassword = () => {
    const setAuthToken = useAuthStore((state) => state.setAuthToken);
    const setUserProfile = useAuthStore((state) => state.setUserProfile);
    const { mutate: resetPasswordMutation } = useMutation({
        mutationKey: 'resetPassword',
        mutationFn: (model) => resetPassword(model),
        onSuccess: (data) => {
            setAuthToken(data.token);
            setUserProfile(data.profile);
            notifications.show({
                title: 'Success',
                message: 'Successfully reset password!',
                color: 'green',
            });
        },
        onError: (error) => {
            notifications.show({
                title: 'Error',
                message: error.message,
                color: 'red',
            });
        },
    });
    return resetPasswordMutation;
};
export default useResetPassword;
